module.exports = __webpack_public_path__ + "media/images/new_culture/bg-12-c230ca1279b2c71cdbcdbf5851a98e58.jpeg";